import moment from 'moment-timezone'
import { put, select } from 'redux-saga/effects'
import { openForm } from 'workspace/actions'
import {
  selectMode,
  selectTimezone,
  selectStoppageTypesForLocation
} from 'workspace/selectors'
import { FormTypes, Modes } from 'workspace/const'

function * formDefaults ({ payload: { type, data } }) {
  const { date } = yield select(state => state.navigation)
  const mode = yield select(selectMode)
  const locations = yield select(state => state.locations.selectedIds)
  const timezone = yield select(selectTimezone)
  const stoppageTypes = yield select(
    selectStoppageTypesForLocation,
    locations[0]
  )

  let defaults = {
    date: date.clone(),
    duration: null,
    quantity: null,
    remarks: '',
    description: '',
    resolution: '',
    userGroupId: null,
    productionStop: null,
    manualDuration: null,
    changeoverDuration: null
  }

  if (mode === Modes.REALIZATION) {
    defaults.locationId = locations[0]
    defaults.startedAt = moment.tz(timezone).startOf('minute')
    defaults.engineeringFinishedAt = moment.tz(timezone).startOf('minute')
    defaults.finishedAt = moment.tz(timezone).startOf('minute')

    if (type === FormTypes.REALIZATION_STOPPAGE && stoppageTypes && stoppageTypes.length > 0) {
      defaults.stoppageTypeId = stoppageTypes[0].id
    }

    if (type === FormTypes.REALIZATION_SCRAP) {
      defaults.reportedAt = moment.tz(timezone).startOf('minute')
    }

    const character =
      type.replace(/^realization/, '').toLowerCase()
    defaults.character = character
  }

  // Transform userGroup object to userGroupId for breakdown forms
  if (data && data.userGroup && typeof data.userGroup === 'object') {
    data = { ...data, userGroupId: data.userGroup.id }
  }

  yield put(openForm(type, { ...defaults, ...data }))
}

export default formDefaults
